@if ($model() != null) {
    <form class="px-1" (ngSubmit)="onSubmit()" #flowDefinitionDetailsHotConfigs="ngForm">
        <div class="scroll-wrapper styled-scrollbar pr-2">
            <!-- Informações -->
            <div class="header ml-1">
                <i class="fas fa-exclamation-circle mt-1 mr-2"></i>

                <div>
                    <p>
                        As configurações desta seção possuem <b>efeito imediato</b> tanto sobre as Definições de Fluxo já publicadas
                        no Portal Público (i.e. no caso do <b>modo Não Listado</b> e das opções relativas à <b>ativação/desativação automática</b>)
                        quanto sobre as Instâncias de Fluxo já em execução no Portal Público (i.e. no caso das opções relativas ao
                        <b>cancelamento automático</b>).
                    </p>
                    <span>
                        Assim sendo, não será necessário versionar o Fluxo para realizar e salvar alterações em opções aqui contidas.
                    </span>
                </div>
            </div>

            <hr />

            <!-- Ativar modo Não Listado -->
            <ng-container>
                <div class="form-group checkbox-group">
                    <mat-checkbox class="ml-0" id="isUnlistedModeActive" name="isUnlistedModeActive" color="primary"
                                  featureHint="flowDefinitionDetailsHotConfigs|Unlisted" featureHintHAlign="right" featureHintShowOn="right"
                                  [ngModel]="$model().isUnlistedModeActive"
                                  (change)="unlistedModeChange($event.checked)"
                    >Ativar modo Não Listado</mat-checkbox>
                </div>
            </ng-container>

            <!-- Permitir cancelamento manual -->
            <ng-container>
                <div class="form-group checkbox-group">
                    <mat-checkbox class="ml-0" id="isCancellingByDeliberation" name="isCancellingByDeliberation" color="primary"
                                  featureHint="flowDefinitionDetailsHotConfigs|cancelByDeliberation" featureHintHAlign="right" featureHintShowOn="right"
                                  [ngModel]="$isCancellingByDeliberation()"
                                  (change)="clearCancellationByDeliberation($event.checked)"
                    >Permitir o cancelamento manual das instâncias desta definição de Fluxo</mat-checkbox>
                </div>

                @if ($isCancellingByDeliberation()) {
                    <div class="form-group auto-option ml-3 mb-2">
                        <!-- Classificação Documental -->
                        <div class="content-type-text-row px-3">
                            <div class="form-group">
                                <h5>
                                    <span>Classificação Documental</span>
                                </h5>
                            </div>

                            <document-class [_model]="$cancellationDocumentClass()"
                                            [_flowDefinitionOrganizationId]="$model().organizationId"
                                            (_modelChange)="onUpdateCancellationDocumentClass($event)"
                            ></document-class>
                        </div>

                        <!-- Nível de Acesso -->
                        <div class="content-type-text-row px-3">
                            <div class="form-group">
                                <h5>
                                    <span>Nível de Acesso do Documento</span>
                                </h5>
                            </div>

                            <access-level [_model]="$cancellationAccessLevel()"
                                          [_flowDefinitionOrganizationId]="$model().organizationId"
                                          (_modelChange)="onUpdateCancellationAccessLevel($event)"
                            ></access-level>
                        </div>
                    </div>
                }
            </ng-container>

            <!-- Habilitar ativação automática -->
            <ng-container>
                <div class="form-group checkbox-group"
                     featureHint="flowDefinitionDetailsHotConfigs|AutomaticActivation" featureHintHAlign="right" featureHintExclusiveGroup
                >
                    <mat-checkbox class="ml-0" id="hasAutomaticFlowDefinitionActivation" name="hasAutomaticFlowDefinitionActivation" color="primary"
                                  [ngModel]="$configSchema().hasAutomaticFlowDefinitionActivation"
                                  (change)="clearAutoActivateChildren($event.checked)"
                    >Habilitar a ativação automática desta definição de Fluxo</mat-checkbox>
                </div>

                <div class="form-group auto-option ml-3 mb-2"
                     [class.disabled]="!$configSchema().hasAutomaticFlowDefinitionActivation || !$isAutoActivateSinceFlowDefinitionPublication()"
                >
                    <mat-checkbox class="m-0 mr-2" id="isAutoActivateSinceFlowDefinitionPublication" name="isAutoActivateSinceFlowDefinitionPublication" color="primary"
                                  [ngModel]="$isAutoActivateSinceFlowDefinitionPublication()"
                                  [disabled]="!$configSchema().hasAutomaticFlowDefinitionActivation"
                                  (change)="clearAutoActivateSinceFlowDefinitionPublication($event.checked)"
                    >
                        <span>Após</span>
                        <input type="text" class="form-control mx-1" id="daysSinceFlowDefinitionPublicationToAutoActivate" name="daysSinceFlowDefinitionPublicationToAutoActivate"
                               [ngModel]="$configSchema().daysSinceFlowDefinitionPublicationToAutoActivate"
                               [disabled]="!$configSchema().hasAutomaticFlowDefinitionActivation || !$isAutoActivateSinceFlowDefinitionPublication()"
                               (change)="daysSinceFlowDefinitionPublicationToAutoActivateChange($event.target.value)"
                        >
                        <span>dia(s) desde a última publicação desta definição de Fluxo</span>
                    </mat-checkbox>
                </div>

                <div class="form-group auto-option date ml-3 mb-2"
                     [class.disabled]="!$configSchema().hasAutomaticFlowDefinitionActivation || !$isAutoActivateOnDateTime()"
                >
                    <mat-checkbox class="m-0 mr-2" id="isAutoActivateOnDateTime" name="isAutoActivateOnDateTime" color="primary"
                                  [ngModel]="$isAutoActivateOnDateTime()"
                                  [disabled]="!$configSchema().hasAutomaticFlowDefinitionActivation"
                                  (change)="clearAutoActivateOnDateTime($event.checked)"
                    >
                        <span>Na seguinte data e hora:</span>

                        <datetime-picker [value]="$configSchema().dateTimeToAutoActivateFlowDefinition"
                                         [disabled]="!$configSchema().hasAutomaticFlowDefinitionActivation || !$isAutoActivateOnDateTime()"
                                         (valueChange)="dateTimeToAutoActivateFlowDefinitionChange($event)"
                        ></datetime-picker>
                    </mat-checkbox>
                </div>
            </ng-container>

            <!-- Habilitar desativação automática -->
            <ng-container>
                <div class="form-group checkbox-group"
                     featureHint="flowDefinitionDetailsHotConfigs|AutomaticDeactivation" featureHintHAlign="right" featureHintExclusiveGroup
                >
                    <mat-checkbox class="ml-0" id="hasAutomaticFlowDefinitionDeactivation" name="hasAutomaticFlowDefinitionDeactivation" color="primary"
                                  [ngModel]="$configSchema().hasAutomaticFlowDefinitionDeactivation"
                                  (change)="clearAutoDeactivateChildren($event.checked)"
                    >Habilitar a desativação automática desta definição de Fluxo</mat-checkbox>
                </div>

                <div class="form-group auto-option ml-3 mb-2"
                     [class.disabled]="!$configSchema().hasAutomaticFlowDefinitionDeactivation || !$isAutoDeactivateSinceFlowDefinitionActivation()"
                >
                    <mat-checkbox class="m-0 mr-2" id="isAutoDeactivateSinceFlowDefinitionActivation" name="isAutoDeactivateSinceFlowDefinitionActivation" color="primary"
                                  [ngModel]="$isAutoDeactivateSinceFlowDefinitionActivation()"
                                  [disabled]="!$configSchema().hasAutomaticFlowDefinitionDeactivation"
                                  (change)="clearAutoDeactivateSinceFlowDefinitionActivation($event.checked)"
                    >
                        <span>Após</span>
                        <input type="text" class="form-control mx-1" id="daysSinceFlowDefinitionActivationToAutoDeactivate" name="daysSinceFlowDefinitionActivationToAutoDeactivate"
                               [ngModel]="$configSchema().daysSinceFlowDefinitionActivationToAutoDeactivate"
                               [disabled]="!$configSchema().hasAutomaticFlowDefinitionDeactivation || !$isAutoDeactivateSinceFlowDefinitionActivation()"
                               (change)="daysSinceFlowDefinitionActivationToAutoDeactivateChange($event.target.value)"
                        >
                        <span>dia(s) desde a última ativação ou publicação desta definição de Fluxo</span>
                    </mat-checkbox>
                </div>

                <div class="form-group auto-option date ml-3 mb-2"
                     [class.disabled]="!$configSchema().hasAutomaticFlowDefinitionDeactivation || !$isAutoDeactivateOnDateTime()"
                >
                    <mat-checkbox class="m-0 mr-2" id="isAutoDeactivateOnDateTime" name="isAutoDeactivateOnDateTime" color="primary"
                                  [ngModel]="$isAutoDeactivateOnDateTime()"
                                  [disabled]="!$configSchema().hasAutomaticFlowDefinitionDeactivation"
                                  (change)="clearAutoDeactivateOnDateTime($event.checked)"
                    >
                        <span>Na seguinte data e hora:</span>

                        <datetime-picker [value]="$configSchema().dateTimeToAutoDeactivateFlowDefinition"
                                         [disabled]="!$configSchema().hasAutomaticFlowDefinitionDeactivation || !$isAutoDeactivateOnDateTime()"
                                         (valueChange)="dateTimeToAutoDeactivateFlowDefinitionChange($event)"
                        ></datetime-picker>
                    </mat-checkbox>
                </div>
            </ng-container>

            <!-- Habilitar cancelamento automático -->
            <ng-container>
                <div class="form-group checkbox-group"
                     featureHint="flowDefinitionDetailsHotConfigs|AutomaticCancellation" featureHintHAlign="right" featureHintShowOn="right"
                >
                    <mat-checkbox class="ml-0" id="hasAutomaticFlowInstanceCancellation" name="hasAutomaticFlowInstanceCancellation" color="primary"
                                  [ngModel]="$configSchema().hasAutomaticFlowInstanceCancellation"
                                  (change)="clearAutoCancelChildren($event.checked)"
                    >Habilitar o cancelamento automático das instâncias deste Fluxo</mat-checkbox>
                </div>

                <div class="form-group auto-option ml-3 mb-2"
                     [class.disabled]="!$configSchema().hasAutomaticFlowInstanceCancellation || !$isAutoCancelSinceFlowInstanceStart()"
                >
                    <mat-checkbox class="m-0 mr-2" id="isAutoCancelSinceFlowInstanceStart" name="isAutoCancelSinceFlowInstanceStart" color="primary"
                                  [ngModel]="$isAutoCancelSinceFlowInstanceStart()"
                                  [disabled]="!$configSchema().hasAutomaticFlowInstanceCancellation"
                                  (change)="clearAutoCancelSinceFlowInstanceStart($event.checked)"
                    >
                    <span>Após</span>
                        <input type="text" class="form-control mx-1" id="daysSinceFlowInstanceStartToAutoCancel" name="daysSinceFlowInstanceStartToAutoCancel"
                               [ngModel]="$configSchema().daysSinceFlowInstanceStartToAutoCancel"
                               [disabled]="!$configSchema().hasAutomaticFlowInstanceCancellation || !$isAutoCancelSinceFlowInstanceStart()"
                               (change)="daysSinceFlowInstanceStartToAutoCancelChange($event.target.value)"
                        >
                        <span>dia(s) desde o início da instância do Fluxo</span>
                    </mat-checkbox>
                </div>

                <div class="form-group auto-option ml-3 mb-2"
                     [class.disabled]="!$configSchema().hasAutomaticFlowInstanceCancellation || !$isAutoCancelSinceFlowInstanceLastUpdate()"
                >
                    <mat-checkbox class="m-0 mr-2" id="isAutoCancelSinceFlowInstanceLastUpdate" name="isAutoCancelSinceFlowInstanceLastUpdate" color="primary"
                                  [ngModel]="$isAutoCancelSinceFlowInstanceLastUpdate()"
                                  [disabled]="!$configSchema().hasAutomaticFlowInstanceCancellation"
                                  (change)="clearAutoCancelSinceFlowInstanceLastUpdate($event.checked)"
                    >
                        <span>Após</span>
                        <input type="text" class="form-control mx-1" id="daysSinceFlowInstanceLastUpdateToAutoCancel" name="daysSinceFlowInstanceLastUpdateToAutoCancel"
                               [ngModel]="$configSchema().daysSinceFlowInstanceLastUpdateToAutoCancel"
                               [disabled]="!$configSchema().hasAutomaticFlowInstanceCancellation || !$isAutoCancelSinceFlowInstanceLastUpdate()"
                               (change)="daysSinceFlowInstanceLastUpdateToAutoCancelChange($event.target.value)"
                        >
                        <span>dia(s) desde a última atualização na instância do Fluxo</span>
                    </mat-checkbox>
                </div>

                <div class="form-group auto-option date ml-3 mb-2"
                     [class.disabled]="!$configSchema().hasAutomaticFlowInstanceCancellation || !$isAutoCancelOnDateTime()"
                >
                    <mat-checkbox class="m-0 mr-2" id="isAutoCancelOnDateTime" name="isAutoCancelOnDateTime" color="primary"
                                  [ngModel]="$isAutoCancelOnDateTime()"
                                  [disabled]="!$configSchema().hasAutomaticFlowInstanceCancellation"
                                  (change)="clearAutoCancelOnDateTime($event.checked)"
                    >
                        <span>Na seguinte data e hora:</span>

                        <datetime-picker [value]="$configSchema().dateTimeToAutoCancelFlowInstance"
                                         [disabled]="!$configSchema().hasAutomaticFlowInstanceCancellation || !$isAutoCancelOnDateTime()"
                                         (valueChange)="dateTimeToAutoCancelFlowInstanceChange($event)"
                        ></datetime-picker>
                    </mat-checkbox>
                </div>
            </ng-container>
        </div>

        <!-- Botões -->
        <div class="form-footer text-right mb-1">
            <hr class="mt-0" />

            <!-- ConfigSchema -->
            <button type="button" class="btn btn-outline-secondary float-left ml-1"
                    (click)="showConfigSchema()"
            >Editar código-fonte</button>

            <!-- Cancelar -->
            <button type="button" class="btn btn-outline-danger mr-2"
                    (click)="closeForm()"
            >Cancelar</button>

            <!-- Salvar -->
            <button type="submit" class="btn btn-outline-primary"
                    [disabled]="!flowDefinitionDetailsHotConfigs.form.valid || !isLatestVersion"
            >Aplicar Configurações Imediatas</button>
        </div>
    </form>

    <!-- Modal do ConfigSchema -->
    <ng-template #configSchemaRef>
        <i class="button fas fa-times close" matTooltip="Fechar" (click)="configSchemaDialog.close()"></i>

        <button type="button" class="button btn btn-primary" (click)="Utils.copyToClipboard(configSchemaEditorRef, copyInfoRef);">
            <i class="fas fa-copy mr-2"></i>
            <span>Copiar conteúdo</span>
        </button>

        <button type="button" class="button btn btn-outline-info info" #copyInfoRef><span>Conteúdo copiado!</span></button>
        <button type="button" class="button btn btn-outline-info info" #pasteInfoRef><span>Conteúdo colado!</span></button>

        <button type="button" class="button btn btn-success right" (click)="Utils.pasteFromClipboard(configSchemaEditorRef, pasteInfoRef)">
            <i class="fas fa-paste mr-2"></i>
            <span>Colar conteúdo</span>
        </button>

        <textarea class="schema-editor form-control styled-scrollbar" [ngModel]="$configSchemaFlat()" #configSchemaEditorRef></textarea>
    </ng-template>
}
